import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
    backgroundColor,
    borderColor,
    menuBoxShadow,
    primaryBoxShadow,
    primaryText,
} from 'styles/theme';

export interface ITileProps {
    children: React.ReactNode;
    navigateTo?: string;
    isExternalLink?: boolean;
    className?: string;
    'aria-label'?: string;
}

const TileContainer = styled.div`
    box-shadow: ${primaryBoxShadow};
    border-radius: 8px;
    border: solid ${borderColor} 2px;
    color: ${primaryText};
    background-color: ${backgroundColor};
    transition: all 0.3s ease-in-out;

    &:hover {
        box-shadow: ${menuBoxShadow};
    }
`;

export function Tile({
    children,
    navigateTo,
    isExternalLink,
    className,
    'aria-label': ariaLabel,
}: ITileProps) {
    const innerContent = (
        <TileContainer
            data-cy="tile-container"
            className={`py-13 px-8 ${navigateTo ? 'cursor-pointer' : ''} tile-container ${
                className ?? ''
            }`}
        >
            <div
                className="flex flex-row flex-grow-1 align-center full-height"
                data-cy="tile-content"
            >
                {children}
            </div>
        </TileContainer>
    );

    if (!navigateTo) {
        return (
            <div aria-label={ariaLabel} className="no-text-decoration">
                {innerContent}
            </div>
        );
    }

    if (isExternalLink) {
        return (
            <a
                aria-label={ariaLabel}
                className="no-text-decoration"
                target="_blank"
                rel="noopener noreferrer"
                href={navigateTo}
            >
                {innerContent}
            </a>
        );
    }

    return (
        <Link
            aria-label={ariaLabel}
            className="no-text-decoration"
            to={navigateTo || '#'}
        >
            {innerContent}
        </Link>
    );
}
